<template>
  <pagefra
    v-loading.fullscreen="deriveLoading"
    :element-loading-text="$l('生成中...')"
  >
    <div class="report-box" id="domain-weekly" v-loading.fullscreen="loading">
      <div class="report-item-box">
        <div class="report-title">
          <div class="title-l">
            <label class="back" v-if="!deriveLoading" @click="$router.go(-1)"
              ><i class="el-icon-arrow-left"></i>{{ $l("返回") }}
            </label>
            <strong>{{ $l("电梯基本信息") }} </strong>
            <span></span>
          </div>
          <div class="title-r">
            <el-button
              type="primary"
              round
              v-if="!deriveLoading"
              @click="handleDerive"
              class="download"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
        <div class="content-box">
          <div class="info-box">
            <div class="code-item">
              <span>{{ $l("所在城市：") }} {{ form.city }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("地盘名称：") }} {{ form.domainName }}</span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("报告确认时间：") }}
                {{ form.confirmTime.split(" ")[0] }}</span
              >
            </div>
            <div class="code-item">
              <span class="ti-input" v-if="!deriveLoading"
                >{{ $l("安全员/安全总监：") }}

                <el-input
                  v-model="form.adminName"
                  placeholder="请输入"
                  maxlength="20"
                />
              </span>
              <span class="ti-input" v-else
                >{{ $l("安全员/安全总监：") }} {{ form.adminName }}
              </span>
            </div>
            <div class="code-item">
              <span
                >{{ $l("台量：") }}
                {{ form.liftCount + form.escalatorCount }}</span
              >
            </div>
            <div class="code-item">
              <span>{{ $l("扶梯：") }} {{ form.escalatorCount }}</span>
            </div>
            <div class="code-item">
              <span>{{ $l("直梯：") }} {{ form.liftCount }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="report-item-box" v-if="indexTableRows.length">
        <div class="content-box">
          <el-table
            class="index-table"
            :data="indexTableRows"
            border
            :span-method="getIndexTableSpan"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('检查部位')"
              min-width="130"
              align="center"
            >
              <template slot-scope="scope">
                {{ $l(scope.row.section.name) }}
              </template>
            </el-table-column>
            <el-table-column :label="$l('检查内容')" min-width="260">
              <template slot-scope="scope">
                {{ $l(scope.row.item.name) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('统计情况')"
              min-width="150"
              align="center"
            >
              <template slot-scope="scope">
                <span class="result-text">{{
                  formatIndexValue(scope.row.item.value)
                }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="section-bottom-box">
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检拍照情况") }} </strong>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <div class="img-item" v-for="(t, i) in files" :key="i">
                <img :src="t.url" />
              </div>
            </div>
          </div>
        </div>
        <div class="report-item-box">
          <div class="report-title">
            <div class="title-l">
              <strong>{{ $l("巡检日志说明") }} </strong>
            </div>
          </div>
          <div class="content-box">
            <div class="explain-box">
              <el-input
                type="textarea"
                maxlength="200"
                resize="none"
                v-model="form.remark"
              >
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="signature-area">
        <div class="sign-title-bar">
          <span class="sign-title">{{ $l("巡检人员签名") }}</span>
          <el-button
            type="primary"
            round
            size="small"
            @click="signVisible = true"
            class="sign-btn"
            v-if="!deriveLoading"
          >
            {{ signatureImg ? $l("重新签名") : $l("签名") }}
          </el-button>
        </div>
        <div class="sign-body">
          <img v-if="signatureImg" :src="signatureImg" class="sign-img" />
        </div>
      </div>
      <sign-dialog
        :visible.sync="signVisible"
        @confirm="onSignConfirm"
      ></sign-dialog>
    </div>
  </pagefra>
</template>

<script>
import dayjs from "dayjs";
dayjs.extend(require("dayjs/plugin/weekOfYear"));
import global from "@/mixins/global.js";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { mapGetters } from "vuex";
import signDialog from "@/components/signDialog.vue";
export default {
  mixins: [global],
  components: { signDialog },
  data() {
    return {
      form: {
        city: "",
        domainName: "",
        confirmTime: "",
        adminName: "",
        liftCount: "",
        escalatorCount: "",
      },
      loading: false,
      files: [],
      exportDetail: false,
      signatureImg: "",
      isSignature: false,
      signVisible: false,
    };
  },
  computed: {
    ...mapGetters(["deriveLoading"]),
    /* 检查指标表格行：检查部位=一级key，检查内容=二级key */
    indexTableRows() {
      const source = this.form.data || {};
      const rows = [];
      Object.keys(source).forEach((sectionName) => {
        const sectionData = source[sectionName] || {};
        const itemNames = Object.keys(sectionData);
        itemNames.forEach((itemName, i) => {
          rows.push({
            section: { name: sectionName },
            item: { name: itemName, value: sectionData[itemName] },
            span: i === 0 ? itemNames.length : 0,
          });
        });
      });
      return rows;
    },
  },
  created() {
    const { query } = this.$route;
    this.params = query;
    if (query.startTime) {
      this.$route.meta.subtitle =
        query.reportType == 1
          ? `（${dayjs(query.startTime).format("YYYY年MM月DD日")} ${this.$l(
              "至"
            )} ${dayjs(query.endTime).format("YYYY年MM月DD日")}）`
          : `（${dayjs(query.startTime).format("YYYY年MM月")}）`;
    }
    this.loadReportData();
  },
  methods: {
    loadReportData() {
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_statistics_domain, {
          params: this.params,
        })
        .then((response) => {
          let result = response.data;
          this.loading = false;
          if (result.code == 0) {
            this.form = result.data;
            result.data.imageList = result.data.imageList || [];
            this.files = result.data.imageList.map((v) => {
              return {
                url: result.data.resourceServerUrl + v.imageUrl,
                image: v,
              };
            });
            this.signatureImg = result.data.signatureUrl
              ? result.data.resourceServerUrl + result.data.signatureUrl
              : "";
            this.isSignature = false;
            if (this.form.noReports > 0) {
              return this.$alert(
                `${
                  this.params.reportType == 1
                    ? this.$l("本周")
                    : this.$l("本月")
                }${
                  this.$l("有") +
                  this.form.noReports +
                  this.$l("份未提交日报，请先提交日报！")
                }`,
                this.$l("提示"),
                {
                  confirmButtonText: this.$l("确定"),
                  callback: () => {
                    sessionStorage.setItem(
                      "elevator_report_list_info",
                      JSON.stringify({
                        openReportList: true,
                        jobNum: this.params.jobNum,
                        startTime: this.params.startTime,
                        endTime: this.params.endTime,
                      })
                    );
                    this.$router.push({
                      name: "elevator",
                      query: {},
                    });
                  },
                }
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    onSignConfirm(img) {
      this.signatureImg = img;
      this.isSignature = true;
    },
    /* 检查指标表格行（检查部位=一级key，检查内容=二级key） */
    getIndexTableSpan({ row, columnIndex }) {
      if (columnIndex === 1) {
        return row.span
          ? { rowspan: row.span, colspan: 1 }
          : { rowspan: 0, colspan: 0 };
      }
      return { rowspan: 1, colspan: 1 };
    },
    /* 结果列显示：数值直接显示，对象显示 正常：x 异常：x */
    formatIndexValue(value) {
      if (value == null) {
        return "";
      }
      if (typeof value === "object") {
        return Object.keys(value)
          .map((k) => `${k}：${value[k] != null ? value[k] : ""}`)
          .join("  ");
      }
      return String(value);
    },
    /* 导出 */
    handleDerive() {
      if (!this.signatureImg) {
        return this.$message(this.$l("请先进行签名"));
      }
      this.$store.commit("setDeriveLoading", true);
      this.exportDetail = true;
      this.$nextTick(() => {
        const elementToExport =
          document.getElementsByClassName("pagefra-main")[0];
        elementToExport.style.height =
          112 + document.getElementById("domain-weekly").scrollHeight + "px";
        html2canvas(elementToExport, {
          useCORS: true,
        })
          .then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF();
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(
              `${
                this.$route.meta.title +
                this.$route.meta.subtitle +
                "_" +
                this.form.domainName
              }.pdf`
            );
            elementToExport.style.height = "auto";
            this.exportDetail = false;
            this.$store.commit("setDeriveLoading", false);
          })
          .catch((err) => {
            console.log(err);
            this.$store.commit("setDeriveLoading", false);
            this.exportDetail = false;
            elementToExport.style.height = "auto";
            this.message(500, "导出失败");
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.report-box {
  padding: 0 20px;
}

.report-item-box {
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;

  .report-title {
    height: 66px;
    padding: 15px 20px;
    border-bottom: 1px solid #c7c7c7;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title-l {
      color: #5c5c5c;

      strong {
        font-size: 18px;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }

  .content-box {
    padding: 15px 20px;

    span,
    label {
      font-size: 14px;
      color: #5c5c5c;
    }
  }
}

.info-box {
  display: flex;
  flex-wrap: wrap;

  .code-item {
    width: 25%;
    line-height: 2.5;
  }
}

.index-table {
  /deep/.el-table__cell {
    padding: 6px 0;
  }
  .result-text {
    font-size: 14px;
    color: #35b6ae;
  }
}

.ti-input {
  display: flex;
  align-items: center;

  .el-input {
    width: 100px;
  }
}

.back {
  margin-right: 15px;
  cursor: pointer;
}

.section-bottom-box {
  display: flex;
  margin-top: 18px;
  gap: 18px;

  & > div {
    width: calc(50% - 9px);
    flex-shrink: 0;

    .report-item-box {
      margin-bottom: 0;
    }
  }
}

.explain-box {
  height: auto;
  min-height: 120px;
  display: flex;
  overflow-x: auto;

  /deep/.el-textarea {
    height: 100%;

    .el-textarea__inner {
      min-height: 120px !important;
    }
  }

  .img-item {
    width: 100px;
    margin-right: 20px;

    img {
      width: 100px;
      height: 100px;
    }

    .o {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #ff5733;
        cursor: pointer;
      }

      span:last-child {
        color: #07a89e;
      }
    }
  }
}

.signature-area {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #c7c7c7;
  margin-bottom: 18px;

  .sign-title-bar {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .sign-title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    .sign-btn {
      background-color: #35b6ae;
      border-color: #35b6ae;
      color: #fff;
    }
  }

  .sign-body {
    padding: 0 20px 20px;

    .sign-img {
      max-height: 80px;
      max-width: 200px;
      border: 1px dashed #dcdfe6;
      border-radius: 4px;
      padding: 4px;
      background: #fafafa;
    }
  }
}

.uploading {
  background-color: #ff6969;
  border-color: #ff6969;
}

.download {
  margin-left: 20px;
  background-color: #35b6ae;
  border-color: #35b6ae;
}

.clar {
  background-color: #808396;
  border-color: #808396;
}
</style>
